/** @jsxImportSource @emotion/react */

import { FC } from 'react'
import { Tooltip } from '@mui/material'
import { SelectField } from 'components/Select'
import { FacultyModeCohortYearEnum, PlatformName, RolesEnum } from '__generatedTypes__/globalTypes'
import { BaseItem } from 'components/Autosuggest/Autosuggest'
import * as classes from '../styles'

const PLATFORMS_WITH_FACULTY_MODE = [
  PlatformName.INBDEBooster,
  PlatformName.NBDHEBooster,
  PlatformName.DATBooster,
  PlatformName.OATBooster,
]

type Props = {
  onProductChange: (
    value: {
      id: PlatformName
      title: string
    } | null
  ) => void
  schools: BaseItem[]
  schoolsLoading?: boolean
  role?: RolesEnum
  disabled?: boolean
}

const PRODUCT_ITEMS = Object.values(PlatformName).map((platform) => ({
  id: platform,
  title: platform,
}))

const DISABLED_PRODUCT_ITEMS = Object.values(PlatformName).filter(
  (platform) => !PLATFORMS_WITH_FACULTY_MODE.includes(platform)
)

function formatCohortTitle(str: string) {
  return str
    .replace(/([A-Z])/g, ' $1') // Space before uppercase letters
    .replace(/([a-zA-Z])(\d)/g, '$1 $2') // Space before numbers
    .trim() // Remove any leading/trailing whitespace
    .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
}

export const getCohortItem = (cohort: FacultyModeCohortYearEnum) => ({
  id: cohort,
  title: formatCohortTitle(cohort),
})

export const COHORT_ITEMS = Object.values(FacultyModeCohortYearEnum).map((cohort) => getCohortItem(cohort))

export const renderSchoolItem = (option: BaseItem) => (
  <Tooltip title={option.title}>
    <div css={classes.selectOption}>{option.title}</div>
  </Tooltip>
)

export const FacultyFields: FC<Props> = ({ role, schools, schoolsLoading, onProductChange, disabled }) => (
  <>
    <SelectField
      name="facultyModeProduct"
      label="Faculty Mode - Product"
      items={PRODUCT_ITEMS}
      renderItem={renderSchoolItem}
      placeholder="Product"
      fullWidth
      disabledItemIds={DISABLED_PRODUCT_ITEMS}
      onChange={onProductChange}
      disabled={disabled}
    />
    <SelectField
      name="facultyModeSchool"
      label="Faculty Mode - School"
      items={schools}
      renderItem={renderSchoolItem}
      placeholder="School"
      fullWidth
      loading={schoolsLoading}
      disabled={disabled}
    />
    {role === RolesEnum.User && (
      <SelectField
        name="facultyModeCohort"
        label="Faculty Mode - Cohort"
        items={COHORT_ITEMS}
        renderItem={renderSchoolItem}
        placeholder="Cohort"
        css={classes.cohortField}
        fullWidth
        disabled={disabled}
      />
    )}
  </>
)
